var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fragment",
    [
      _vm._l(_vm.menuTree, function (menu) {
        return [
          menu.children && menu.children.length > 0
            ? _c(
                "el-submenu",
                { key: menu.id, attrs: { index: menu.id.toString() } },
                [
                  _c("template", { slot: "title" }, [
                    _c("i", { class: menu.css }),
                    _c(
                      "span",
                      {
                        attrs: {
                          title: menu.translation
                            ? _vm.$t(menu.translation)
                            : menu.name,
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              menu.translation
                                ? _vm.$t(menu.translation)
                                : menu.name
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("LeftNavOfSpm", { attrs: { menuTree: menu.children } }),
                ],
                2
              )
            : _c(
                "el-menu-item-group",
                { key: menu.id },
                [
                  menu.isMatched && menu.showInMenu !== false
                    ? _c(
                        "el-menu-item",
                        {
                          key: menu.id,
                          attrs: { index: _vm.menuUrlRewrite(menu) },
                        },
                        [
                          _c(
                            "span",
                            [
                              _c(
                                "Tooltips",
                                {
                                  attrs: {
                                    effect: "dark",
                                    text: menu.translation
                                      ? _vm.$t(menu.translation)
                                      : menu.name,
                                    placement: "top",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        menu.translation
                                          ? _vm.$t(menu.translation)
                                          : menu.name
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("i", {
                            staticClass: "el-icon-star-on",
                            class: {
                              collected: _vm.collectMenus.find(
                                (item) => item.url === menu.url
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.handleToggleCollect(menu)
                              },
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }